import { Component, effect, inject } from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { LogoComponent } from '../../icons/logo';
import { CategoryService } from 'src/app/services/category';
import { CommonModule } from '@angular/common';
import { AngleRightComponent } from '../../icons/angle-right';
import { ReportIconComponent } from '../../icons/report';
import { ButtonComponent } from '../../shared/button';
import { MinimizeComponent } from '../../icons/minimize';
import { LocaleService } from 'src/app/services/locale';
import { CalculationCategoriesComponent } from './categories';
import { Payment } from './payment';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { APIService } from 'src/app/services/api';
// @ts-ignore
import html2pdf from 'html2pdf.js';
import { SharedStateService } from 'src/app/services/category.service';
import { Chart } from 'chart.js';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user';
const PREVIEW_MODE_KEY = 'isPreviewMode';

@Component({
  selector: 'app-calculation',
  imports: [
    LogoComponent,
    CommonModule,
    AngleRightComponent,
    ReportIconComponent,
    ButtonComponent,
    MinimizeComponent,
    CalculationCategoriesComponent,
    Payment,
    RouterOutlet,
    // ReportComponent
  ],
  template: `
    <!-- Header -->
    <div
      class="flex fixed justify-between items-center py-1.5 sm:py-2 px-2 sm:px-3 lg:px-6 w-full top-0 backdrop-blur-xl z-50 bg-white/90 border-b border-gray-100"
      *ngIf="!currentcat.isPreviewMode"
    >
      <a (click)="naviagteTohome()" class="cursor-pointer flex-shrink-0">
        <app-logo></app-logo>
      </a>

      <!-- Category Navigation - Hidden on mobile -->
      <div class="hidden lg:inline-flex items-center gap-0.5">
        <ng-container *ngFor="let category of categories; let i = index">
          <div class="inline-flex items-center">
            <span
              class="cursor-pointer text-[14px] px-1.5 py-0.5 rounded transition-colors hover:bg-gray-50"
              [ngClass]="{
                'font-semibold text-[#043B22] bg-[#043B22]/5':
                  currentCategory === i,
                'text-[#616161]': currentCategory !== i,
              }"
              (click)="navigateTop(i)"
            >
              {{ locale.category.heading_category }} {{ i + 1 }}
            </span>
            <app-angle-right></app-angle-right>
          </div>
        </ng-container>
        <div>
          <span
            class="text-[14px] px-1.5 py-0.5 rounded transition-colors cursor-pointer hover:bg-gray-50"
            [ngClass]="{
              'font-semibold text-[#043B22] bg-[#043B22]/5':
                currentCategory === categories.length,
              'text-[#616161]': currentCategory !== categories.length,
            }"
            (click)="navigateTop('summary')"
          >
            {{ locale.category.heading_summary }}
          </span>
        </div>
      </div>

      <!-- Mobile Category Indicator -->
      <div class="lg:hidden text-[12px] font-medium text-[#043B22]">
        <span *ngIf="currentCategory < categories.length"
          >{{ locale.category.heading_category }} {{ currentCategory + 1 }}/{{
            categories.length
          }}</span
        >
        <span *ngIf="currentCategory >= categories.length">{{
          locale.category.heading_summary
        }}</span>
      </div>

      <!-- Actions -->
      <div class="flex gap-1.5 sm:gap-3 items-center">
        <div
          *ngIf="!isInvitedUser"
          (click)="pay()"
          class="flex gap-1 items-center font-medium cursor-pointer text-[12px] text-[#616161] hover:text-[#043B22] transition-colors"
        >
          <app-report-icon></app-report-icon>
          <span class="hidden sm:block">{{ locale.common.button_report }}</span>
        </div>
        <div (click)="confirm = true">
          <app-button text="{{ locale.common.button_close }}">
            <app-minimize></app-minimize>
          </app-button>
        </div>
      </div>
    </div>

    <!-- Close Confirmation Modal -->
    <div
      *ngIf="confirm"
      class="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 p-4"
      (click)="confirm = false"
    >
      <div
        class="bg-white rounded-2xl w-full max-w-sm shadow-2xl overflow-hidden"
        (click)="$event.stopPropagation()"
      >
        <!-- Header with icon -->
        <div class="bg-gradient-to-r from-[#043B22] to-[#065a35] px-5 py-4">
          <div class="flex items-center gap-3">
            <div
              class="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center"
            >
              <svg
                class="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                ></path>
              </svg>
            </div>
            <h3 class="text-white futura text-base">
              {{ locale.close.heading }}
            </h3>
          </div>
        </div>

        <!-- Content -->
        <div class="px-5 py-4 space-y-2">
          <p class="text-[12px] font-semibold text-[#212121]">
            {{ locale.close.subheading }}
          </p>
          <p class="text-[11px] text-[#616161] leading-relaxed">
            {{ locale.close.subheading1 }}
          </p>
          <p class="text-[11px] text-[#616161] leading-relaxed">
            {{ locale.close.subheading2 }}
          </p>
        </div>

        <!-- Actions -->
        <div class="px-5 pb-4 flex gap-3">
          <button
            (click)="confirm = false"
            class="flex-1 px-4 py-2.5 text-[11px] font-medium text-[#616161] bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer"
          >
            {{ locale.close.button_no }}
          </button>
          <a href="/dashboard/calculations" class="flex-1">
            <button
              class="w-full px-4 py-2.5 text-[11px] font-medium text-white bg-[#043B22] hover:bg-[#065a35] rounded-lg transition-colors cursor-pointer"
            >
              {{ locale.close.button_yes }}
            </button>
          </a>
        </div>
      </div>
    </div>

    <app-calculation-categories
      *ngIf="!currentcat.isPreviewMode"
    ></app-calculation-categories>

    <router-outlet *ngIf="currentcat.isPreviewMode"></router-outlet>

    <!-- Payment Modal -->
    <div
      *ngIf="paymentModal"
      (click)="exit($event)"
      class="fixed inset-0 bg-black/50 flex justify-center z-50 overflow-y-auto py-3 px-3"
    >
      <report-payment
        [report]="showReport"
        (close)="closePaymentModal()"
        (preview)="onPreviewModeChange($event)"
      ></report-payment>
    </div>
  `,
  styles: [
    `
      table {
        page-break-inside: auto;
        border-collapse: collapse;
      }

      .active-tab {
        font-weight: 600;
      }

      tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
      }

      td,
      th {
        page-break-inside: avoid !important;
      }
    `,
  ],
})
export class CalculationComponent {
  api = inject(APIService);
  router = inject(Router);
  localeService = inject(LocaleService);
  categoryService = inject(CategoryService);

  locale = this.localeService.locale();
  categories = this.categoryService.categories();
  private routerSub!: Subscription;
  confirm = false;
  reportModal = false;
  paymentModal = false;
  logoPrice = 'price_1RGopnAraWPMLHWjteh7q1Ci';
  reportPrice = 'price_1RGAXnAraWPMLHWjwaDy7mzs';
  private spinner = inject(NgxSpinnerService);
  private userService = inject(UserService);
  currentCategory: any = 0;
  isInvitedUser = localStorage.getItem('isInvitedUser') === 'true';

  constructor(public currentcat: SharedStateService) {
    effect(() => {
      this.locale = this.localeService.locale();
      this.categories = this.categoryService.categories();

      // Invited users with active subscription get full access
      const user = this.userService.user();
      this.isInvitedUser =
        localStorage.getItem('isInvitedUser') === 'true' &&
        !user?.subscriptionPlan;
    });

    this.currentcat.currentCat$.subscribe((cat) => {
      this.currentCategory = parseInt(
        localStorage.getItem('currentCategory') || '0',
        10,
      );
    });

    this.currentcat.highlightCategory$.subscribe((cat) => {
      this.currentCategory = parseInt(
        localStorage.getItem('currentCategory') || '0',
        10,
      );
    });

    this.router.events.subscribe(async (event: any) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes(this.reportPrice)) {
          await this.api.UpdateCompanyDetails({
            id: localStorage.getItem('calculationId') ?? '',
            paidForReport: true,
          });
        } else if (event.url.includes(this.logoPrice)) {
          await this.api.UpdateCompanyDetails({
            id: localStorage.getItem('calculationId') ?? '',
            paidForLogo: true,
          });
        }

        // Handle back navigation from generate-report
        if (
          event.url === '/calculation' ||
          event.url.startsWith('/calculation?')
        ) {
          this.currentcat.isPreviewMode = false;
          localStorage.removeItem(PREVIEW_MODE_KEY);
        } else if (event.url.includes('/calculation/generate-report')) {
          this.currentcat.isPreviewMode = true;
          localStorage.setItem(PREVIEW_MODE_KEY, 'true');
        }
      }
    });
  }

  naviagteTohome() {
    this.router.navigate(['/dashboard/calculations']);
    const currentViewState = localStorage.getItem('currentViewState');
    if (currentViewState === 'stepCompleted') {
      localStorage.setItem('currentViewState', 'question');
    }
  }

  onPreviewModeChange(isPreview: boolean) {
    this.currentcat.isPreviewMode = isPreview;
    localStorage.setItem(PREVIEW_MODE_KEY, String(isPreview));

    if (isPreview) {
      this.router.navigate(['/calculation/generate-report']);
    } else {
      this.router.navigate(['/calculation']);
    }
  }

  ngOnInit() {
    const isPreview = localStorage.getItem('isPreviewMode') === 'true';
    this.currentcat.isPreviewMode = isPreview;

    if (isPreview) {
      this.router.navigate(['/calculation/generate-report']);
    }
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  showReport = () => {
    this.reportModal = true;
    this.paymentModal = false;
  };
  isGeneratingPDF = false;

  download = (event: any) => {
    this.spinner.show();
    event.preventDefault();
    event.stopPropagation();
    const original = document.getElementById('pdfContent');
    if (!original) return console.error('PDF content element not found');
    const downloadBtn = document.getElementById('downloadBtn');
    if (downloadBtn) downloadBtn.style.display = 'none';
    const clone = original.cloneNode(true) as HTMLElement;
    clone.id = 'pdfDownload';
    clone.classList.add('pdf-only');
    const hiddenContainer = document.createElement('div');
    hiddenContainer.style.position = 'absolute';
    hiddenContainer.style.left = '-9999px';
    hiddenContainer.appendChild(clone);
    document.body.appendChild(hiddenContainer);
    const pieCanvas =
      clone.querySelector<HTMLCanvasElement>('#emissionsPieChart');
    if (pieCanvas) {
      try {
        const chart = (Chart as any).getChart(pieCanvas.id);
        const img = document.createElement('img');

        if (chart) {
          img.src = chart.toBase64Image();
        } else {
          img.src = pieCanvas.toDataURL('image/png', 1.0);
        }

        img.style.maxWidth = '100%';
        img.style.height = 'auto';
        pieCanvas.replaceWith(img);
      } catch (err) {
        console.error('Error converting pie chart canvas:', err);
      }
    }
    const fixColors = (el: HTMLElement) => {
      const all = el.querySelectorAll<HTMLElement>('*');
      all.forEach((node) => {
        const style = window.getComputedStyle(node);
        if (style.color.startsWith('oklch') || style.color.startsWith('lab')) {
          (node.style as any).color = '#5D7186';
        }
        if (
          style.backgroundColor.startsWith('oklch') ||
          style.backgroundColor.startsWith('lab')
        ) {
          (node.style as any).backgroundColor = '#FFFFFF';
        }
        if (
          style.borderColor.startsWith('oklch') ||
          style.borderColor.startsWith('lab')
        ) {
          (node.style as any).borderColor = '#DEE2E6';
        }
      });
    };
    const avoidRowBreaks = (el: HTMLElement) => {
      const allRows = el.querySelectorAll('tr');
      allRows.forEach((row) => {
        (row.style as any).pageBreakInside = 'avoid';
        (row.style as any).breakInside = 'avoid';
      });
    };
    const avoidCanvasBreaks = (el: HTMLElement) => {
      const allCanvas = el.querySelectorAll('canvas, img');
      allCanvas.forEach((el) => {
        if (el instanceof HTMLElement) {
          el.style.pageBreakInside = 'avoid';
          el.style.breakInside = 'avoid';
        }
      });
    };
    const avoidElementBreaks = (el: HTMLElement, className: string) => {
      const elements = el.querySelectorAll(`.${className}`);
      elements.forEach((el) => {
        if (el instanceof HTMLElement) {
          el.style.pageBreakInside = 'avoid';
          el.style.breakInside = 'avoid';
        }
      });
    };

    fixColors(clone);
    avoidRowBreaks(clone);
    avoidCanvasBreaks(clone);
    avoidElementBreaks(clone, 'avoid-break-div');

    const options = {
      margin: 0,
      filename: 'carbonFootprint.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        useCORS: true,
        logging: false,
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait',
      },
      pagebreak: {
        mode: ['css', 'legacy'],
        before: '.pbk',
      },
    };
    html2pdf()
      .set(options)
      .from(clone)
      .save()
      .then(() => {
        document.body.removeChild(hiddenContainer);
        if (downloadBtn) downloadBtn.style.display = '';
        this.reportModal = false;
        this.spinner.hide();
      });
  };

  private oklchToHex(oklchValue: string): string {
    if (oklchValue.includes('oklch(0.5 0.1 120)')) return '#6a7282';
    if (oklchValue.includes('oklch(0.92 0.01 100)')) return '#eaeaea';
    if (oklchValue.includes('oklch(0.95 0.01 100)')) return '#f5f5f5';
    return '#ffffff';
  }

  pay = async () => {
    this.paymentModal = true;
  };

  exit = (e: any) => {
    e.stopPropagation();
    this.reportModal = false;
    this.paymentModal = false;
    localStorage.removeItem(PREVIEW_MODE_KEY);
    localStorage.removeItem('setLogo');
  };
  getCurrentCat(i: any) {
    this.currentCategory = i;

    this.currentcat.setCurrentCategory(i);
  }

  closePaymentModal() {
    this.paymentModal = false;
  }

  navigateTop(target: number | 'summary') {
    if (target === 'summary') {
      this.currentcat.setCurrentCategory(this.categories.length);
      this.currentcat.setViewState('summary');
      localStorage.setItem('currentCategory', '6');
      this.currentCategory = 6;
      localStorage.setItem('currentViewState', 'summary');
      return;
    } else {
      localStorage.setItem('currentCategory', String(target));
    }
    this.currentcat.setCurrentCategory(target);
    this.currentcat.setHighlightCategory(target);
    this.currentcat.setViewState('question');
    localStorage.setItem('currentQuestion', '0');
    localStorage.setItem('currentViewState', 'question');
  }
}
